import { Form, Input, InputNumber } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { FieldValue } from 'app/components/commons/Hotel/Contacts/FieldView/FieldView';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import styles from '../General.module.scss';

const RULES = [{ required: true }];

export const Identity = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  return (
    <>
      <FormLineLayout label="Hotel name" isRequired>
        <Form.Item name="name" rules={isEditMode ? RULES : undefined}>
          {isEditMode ? <Input /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Slug">
        <Form.Item name="slug">
          {isEditMode ? <Input disabled /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout
        label="Stars"
        isRequired
        rightClassName={styles.numberField}
      >
        <Form.Item name="stars" rules={isEditMode ? RULES : undefined}>
          {isEditMode ? (
            <InputNumber min={0} max={5} placeholder="1 - 5" />
          ) : (
            <FieldValue />
          )}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout
        label="Room count"
        isRequired
        rightClassName={styles.numberField}
      >
        <Form.Item name="roomCount" rules={isEditMode ? RULES : undefined}>
          {isEditMode ? (
            <InputNumber min={0} step={10} placeholder="10 - 500" />
          ) : (
            <FieldValue />
          )}
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
